import React from 'react';
import { FormattedMessage as Translation } from 'react-intl';

// todo: make them consistent across platform and filter versions
export const getViewOptions = () => [
    {
        name: <Translation id="gallery" />,
        key: 'big',
        icon: 'big'
    },
    {
        name: <Translation id="list" />,
        key: 'list',
        icon: 'list'
    },
    {
        name: <Translation id="mosaic" />,
        key: 'grid',
        icon: 'grid'
    }
];

export const viewTypeTrackDictionary = {
    list: 'list',
    big: 'gallery',
    grid: 'mosaic'
};

export const viewTypeTanakConfig = {
    list: {
        pwaCode: 'list',
        icon: 'List'
    },
    gallery: {
        pwaCode: 'big',
        icon: 'Gallery'
    },
    masonry: {
        pwaCode: 'grid',
        icon: 'Mosaic'
    }
};
